<div class="claim-detail-wrapper grid-container">

  <div class="claim-detail-header-section grid-container">

    <div class="claim-detail-header-title">Claim <span
    data-cy="claim-detail-page-claim-number">{{claimDetail.number}}</span></div>

    <div [ngClass]="['claim-detail-header-status header-status', claimDetail.status.code]">
      <span data-cy="claim-detail-page-claim-status">{{claimDetail.status.code}}</span></div>

      <div class="grid-item">
        <span class="claim-detail-header-menu" ngbDropdown data-cy="claim-detail-element-menu">
          <app-tooltip [dynamic]="false" message="Claim actions" class="display-inline-flex">
            <span class="iwp-icon-gen_kontextmenu" ngbDropdownToggle></span>
          </app-tooltip>
          <div ngbDropdownMenu id="override-dropdown-position">
            @if (userService.hasPermissions([Permission.PARTNER_CLAIM_SEND])) {
              <div data-cy="claim-list-element-menu-send"
                (click)="!fileManagerOffline && canPerformAction(claimDetail, AvailableActions.SUBMIT) && contextMenuSend()"
                [class.disable]="!canPerformAction(claimDetail, AvailableActions.SUBMIT)  || fileManagerOffline"
              ngbDropdownItem>Send</div>
            }
            @if (userService.hasPermissions([Permission.PARTNER_CLAIM_EDIT])) {
              <div data-cy="claim-list-element-menu-edit"
                (click)="canPerformAction(claimDetail, AvailableActions.EDIT) && contextMenuEdit()"
                [class.disable]="!canPerformAction(claimDetail, AvailableActions.EDIT)"
              ngbDropdownItem>Edit</div>
            }
            <div class="separator"></div>
            @if (userService.hasPermissions([Permission.PARTNER_CLAIM_DELETE])) {
              <div data-cy="claim-list-element-menu-delete"
                (click)="canPerformAction(claimDetail, AvailableActions.DELETE) && deleteClaim(claimDetail)"
                [class.disable]="!canPerformAction(claimDetail, AvailableActions.DELETE)"
              ngbDropdownItem>Delete</div>
            }
          </div>
        </span>
      </div>
      <div class="claim-detail-header-separator"></div>
      <div class="claim-detail-header-reference-number" data-cy="claim-detail-header-reference-number">
        <app-tooltip [dynamic]="false" [disable]="!showReferenceNumberTooltip()"
          message="The reference number is registered only after the Claim submission"
          class="display-inline-flex">
          @if (showRefLabel()) {
            <span class="claim-detail-header-claim-reference-number-label"
            data-cy="claim-detail-header-claim-reference-number-label">Ref. No.</span>
          }
          <span [ngClass]="getCssClass()"
          data-cy="claim-detail-header-claim-reference-number">{{getReferenceNumberLabel()}}</span>
        </app-tooltip>
      </div>
    </div>

    @if (showClaimProcessBar()) {
      <app-claim-progress
      [model]="statusSchemaView"></app-claim-progress>
    }

    <div class="claim-detail-information-section">
      <div class="section-heading" data-cy="claim-detail-page-information-section-title">Claim information</div>
      <div>
        <app-claim-information-display [claimInformation]="informationDetail"
          [attachments]="attachments"
          [directory]="claimDetail.attachmentDirectory"
          [requiredAttachments]="informationDetail.claimCode.requiresAttachments"
          [fileManagerOffline]="fileManagerOffline"
        [refreshAttachments]="refreshAttachments"></app-claim-information-display>
      </div>
    </div>

    <div class="claim-detail-positions-section">
      <app-material-position-table
        [showContextMenu]="false"
        [showSectionTitle]="true"
        [showMaterialTitle]="false"
        [showButtonAdd]="false"
        [positions]="positions"
        [material]="claimDetail.material"
        [clearPositionTable]="false"
        [partnerCode]="claimDetail.partner.code"
        [supplyingPackingPlantCode]="claimDetail.supplyingPackingPlant.code">
      </app-material-position-table>

    </div>
  </div>


  <ng-template #tooltip>
    @if (statusSchemaView.justification) {
      <div style="white-space: pre-line;">
        {{statusSchemaView.justification}}
      </div>
    }
  </ng-template>
